import { useCookies } from 'vue3-cookies'
import * as types from '@/store/mutation-types'
import { WebUtil } from './webUtil'
export const SessionUtil = {

    clearCookies : function(key) {
        useCookies().cookies.remove(key);
        // console.log('key : ' + useCookies().cookies.isKey(key));
    },

    setCookies: function(key, val) {
        useCookies().cookies.set(key, val, '1y', '/', '', true, 'None');

        // expireTimes: "30d",
        // path: "/",
        // domain: '',
        // secure: true,
        // sameSite: "None"
    },
    getCookies: function(key) {
        return useCookies().cookies.get(key);
    },

    // LocalStorage
    setLocalStorageData: function(key, obj, useCache){
        var expireTime = new Date();
        
        if (useCache === undefined || useCache != false) {
            expireTime.setMinutes(expireTime.getMinutes() + 240);

            obj['expireTime'] = expireTime.getTime();
        }

        window.localStorage.setItem(key, JSON.stringify(obj));
    },

    getLocalStorageData: function(key, useCache) {
        var nowTime = new Date().getTime();
        let obj = window.localStorage.getItem(key);
        let dataObj = '';
        if ( WebUtil.isNotNull(obj) ) {
            dataObj = JSON.parse(obj);
        }
        if (dataObj == null) {
            return null;
        }

        if (useCache !== undefined && useCache == false) {
            return dataObj;
        } else {
            if (dataObj['expireTime'] != null && nowTime < dataObj['expireTime']) {
                return dataObj;
            } else {
                return null;
            }
        }
    },
    removeLocalStorageData: function(key) {
        window.localStorage.removeItem(key);
    },
    
    clearLocalStorageData: function() {
        window.localStorage.clear();
    },

    setToknData: function(key, obj, useCache){
        var expireTime = new Date();
        
        if (useCache === undefined || useCache != false) {
            // 토큰 유효기간 설정 
            // 분 기준
            expireTime.setMinutes(expireTime.getMinutes() + 1440);

            obj['expireTime'] = expireTime.getTime();
        }

        window.localStorage.setItem(key, JSON.stringify(obj));
    },

    getToknData: function(key, useCache) {
        var nowTime = new Date().getTime();
        var dataObj = JSON.parse(window.localStorage.getItem(key));
        
        if (dataObj == null) {
            return null;
        }

        if (useCache !== undefined && useCache == false) {
            return dataObj;
        } else {
            if (dataObj['expireTime'] != null && nowTime < dataObj['expireTime']) {
                return dataObj;
            } else {
                return null;
            }
        }
    },

    setToken: function(token) {
        this.setToknData(types.TOKN, {'TOKN': token});
    },

    getToken: function() {
        const data = this.getToknData(types.TOKN);
        if ( !!data ) {
            return data['TOKN']
        } else {
            return '';
        }
    },

    clearToken: function() {
        this.removeLocalStorageData(types.TOKN);
    },

    setUserInfo: function(userInfo) {
        this.setLocalStorageData(types.USER_INFO, userInfo, false);
    },

    getUserInfo: function() {
        return this.getLocalStorageData(types.USER_INFO, false);
    },

    clearUserInfo: function() {
        this.removeLocalStorageData(types.USER_INFO);
    },
    
    getUserId: function() {
        if ( !!this.getUserInfo() ) {
            return this.getUserInfo().userId;
        } else {
            return '';
        }
        
    },

    getUserNo: function() {
        if ( !!this.getUserInfo() ) {
            return this.getUserInfo().membNo;
        } else {
            return '';
        }
    },

    getUserNm: function() {
        if ( !!this.getUserInfo() ) {
            return this.getUserInfo().userNm;
        } else {
            return '';
        }
    },

    setChildren: function(children) {
        // console.log(typeof children + '/' + children);
        // if ( typeof children === 'array' ) {
        //     console.log('array');
        // } else if ( typeof children === 'object' ) {
        //     console.log('object');
        // }


        if ( !!children && children.length > 0 ) {
            if ( typeof children === 'object' ) {
                this.setCookies(types.CHILDREN, JSON.stringify(children));
            } else {
                this.setCookies(types.CHILDREN, children);
            }
        } else {
            this.setCookies(types.CHILDREN, '');
        }
    },

    getChildren: function() {
        // console.log(this.getCookies(types.CHILDREN));
        
        let children = this.getCookies(types.CHILDREN);
        // console.log(typeof children + '/' + children);
        if ( !!children ) {
            if ( typeof children === 'object' ) {
                return children;
            } else {
                return JSON.parse(children);
            }
        } else {
            return children;
        }
    },

    clearChildren: function() {
        this.clearCookies(types.CHILDREN);
    },

    setAutoLoginYn: function(yn) { 
        // this.setCookies('AUTO_LOGIN_YN', yn);
        this.setLocalStorageData('AUTO_LOGIN_YN', yn);
    },

    getAutoLoginYn: function() {
        // return this.getCookies('AUTO_LOGIN_YN');
        return this.getLocalStorageData('AUTO_LOGIN_YN');
    },


    setUserRoleList: function(roleList) {
        this.setLocalStorageData(types.ROLE_CD, {'ROLE_CD': roleList}, false);
    },

    getUserRoleList: function() {
        const data = this.getLocalStorageData(types.ROLE_CD, false);
        if( !!data ) {
            return data['ROLE_CD']
        } else {
            return '';
        }
    },
    clearUserRoleList:function(){
        // this.clearCookies(types.ROLE_CD);
        this.clearLocalStorageData(types.ROLE_CD);
    },

    setCmonCdList: function(cmonCdList){
        var expireTime = new Date();
        var userCache  = expireTime.getMinutes() + 1440;
        this.setLocalStorageData('CMON_CD_LIST', {'cmonCdList':cmonCdList},userCache);
    },
    getCmonCdList: function(){
        var cmonCdList = this.getLocalStorageData('CMON_CD_LIST', false);
        
        if(cmonCdList != null){
            return cmonCdList;
        }
    },
    clearCmonCdList: function(){
        this.removeLocalStorageData('CMON_CD_LIST');
    },    
}